import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, ColumnName, MappingState } from '../../../../common/types';

export type SetNextSelectedColumnAction = (goForward: boolean) => Action<State, void, void>;

const getNextSelectedColumn = (
	mappingState: MappingState,
	goForward: boolean,
): ColumnName | undefined => {
	const visibleColumns = mappingState.columnOrder.filter(
		(colName) => mappingState.columns[colName].isVisible,
	);

	if (visibleColumns.length <= 1) return undefined;
	if (!mappingState.selectedColumn)
		return goForward ? visibleColumns[1] : visibleColumns[visibleColumns.length - 2];

	const indexOfSelected = visibleColumns.findIndex(
		(colName) => colName === mappingState.selectedColumn,
	);

	const nextIndex = goForward ? indexOfSelected + 1 : indexOfSelected - 1;

	if (nextIndex < 0 || nextIndex >= visibleColumns.length) return undefined;
	return visibleColumns[nextIndex];
};

export const setNextSelectedColumn =
	(goForward: boolean) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const { mappingState } = getState();

		if (mappingState === null) return;

		setState({
			mappingState: {
				...mappingState,
				selectedColumn: getNextSelectedColumn(mappingState, goForward),
			},
		});
	};
